import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AuthService } from 'ng2-ui-auth';

declare let Dropzone: any;
declare let swal: any;
@Component({
    selector: 'app-image-upload',
    templateUrl: 'image-upload.component.html',
    styleUrls: ['image-upload.component.scss']
})

export class ImageUploadComponent implements OnInit {
    public dropzone;
    @Input('innerImageSrc') innerImageSrc: string = '';
    @Input('small') small: boolean = false;
    @Input('maxWidth') maxWidth: boolean = false;
    @Input('uploaderId') uploaderId: string;
    @Output() public successImageUrl = new EventEmitter();
    public srcModal = false;
    public inputSrc = '';

    constructor(private auth: AuthService) { }

    ngOnInit() {
    }

    initUploader() {
        try {
            if ($(`#${this.uploaderId}`)) {
                Dropzone.autoDiscover = false;
                this.dropzone = new Dropzone(`#${this.uploaderId}`, {
                    url: '/api/upload/multiV2',
                    paramName: "file", // The name that will be used to transfer the file
                    maxFiles: 1,
                    maxFilesize: 5, // MB
                    addRemoveLinks: true,
                    dictRemoveFile: '파일 삭제',
                    acceptedFiles: "image/*",
                    headers: { 'Authorization': `Bearer ${this.auth.getToken()}` },
                    accept: function(file, done) {
                        done();
                    },
                    sending: function(file, xhr, formData) {
                        // Will send the filesize along with the file as POST data.
                        // 추가적인 데이터를 여기에 입력하십시오! req. body 객체에서 확인할수 있음!
                        formData.append("extra", true);
                    },
                    success: (result) => {
                        setTimeout(() => {
                            this.dropzone.files.forEach(file => {
                                this.dropzone.removeFile(file)
                            })
                        }, 1000);
                        this.successImageUrl.emit(JSON.parse(result.xhr.response).files.fileURL)
                    },
                    error: (err) => {
                        console.log(err)
                        setTimeout(() => {
                            this.dropzone.files.forEach(file => {
                                this.dropzone.removeFile(file)
                            })
                        }, 1000);
                        this.successImageUrl.emit('assets/custom/sahwa-upload-fail.png')
                    },
                })
            }
        } catch (e: any) {
        }
    }
    deleteImage() {
        swal({
            title: '정말 삭제하시겠습니까?',
            type: 'warning',
            showCancelButton: true,
            cancelButtonText: '취소',
            reverseButtons: true
        }).then((result) => {
            if (result.value) {
                this.successImageUrl.emit('');
            }
        });

    }

    ngAfterViewInit() {
        this.initUploader();
    }

    ngOnDestroy() {
        if (this.dropzone) {
            this.dropzone.destroy();
        }
    }

    addSrc() {
        this.successImageUrl.emit(this.inputSrc);
        this.dropzone.removeFile(this.inputSrc);
    }

    openSrcModal(type: boolean) {
        event.stopPropagation();
        this.srcModal = type;
        if (type) {
            document.querySelector('body').classList.add('overflow-hidden');
        } else {
            document.querySelector('body').classList.remove('overflow-hidden');
        }
    }
}
